import React, { useRef } from "react";
import Tree from "react-d3-tree";
import PageHeader from "../../../../components/PagesComponents/UniversalComponents/PageHeader.component.jsx";
import "../../../../styles/Pages/Organizational/Management/Structure/Structure.style.css";
import ProfileInfoCard from "../../../../components/PagesComponents/Organizational/Management/Structure/ProfileInfoCard.component.jsx";
import profileImg from "../../../../assets/Images/TestImg/profileImage.png";
import TreeCustomElement from "../../../../components/PagesComponents/Organizational/Management/Structure/TreeCustomElement.component.jsx";
import { Helmet } from "react-helmet";

const Body = ({ boardStructure, representColors }) => {
  const treeRef = useRef();

  const nodeVisible = () => {};

  return (
    <div className="managementStructure">
      <Helmet>
        <title>Structure</title>
      </Helmet>
      <PageHeader />
      {/* profile view cards */}
      <div className="userProfileCardContainerSlider">
        <div className="userProfileCardContainer">
          <ProfileInfoCard
            name="Abir Rousan"
            profileImage={profileImg}
            role="President"
            color={"#F498C6"}
          />
          <ProfileInfoCard
            name="Abir Rousan"
            profileImage={profileImg}
            role="President"
            color={"#F498C6"}
          />
          <ProfileInfoCard
            name="Abir Rousan"
            profileImage={profileImg}
            role="President"
            color={"#F498C6"}
          />
          <ProfileInfoCard
            name="Abir Rousan"
            profileImage={profileImg}
            role="President"
            color={"#F498C6"}
          />
          <ProfileInfoCard
            name="Abir Rousan"
            profileImage={profileImg}
            role="President"
            color={"#F498C6"}
          />
          <ProfileInfoCard
            name="Abir Rousan"
            profileImage={profileImg}
            role="President"
            color={"#F498C6"}
          />
          <ProfileInfoCard
            name="Abir Rousan"
            profileImage={profileImg}
            role="President"
            color={"#F498C6"}
          />
          <ProfileInfoCard
            name="Abir Rousan"
            profileImage={profileImg}
            role="President"
            color={"#F498C6"}
          />
          <ProfileInfoCard
            name="Abir Rousan"
            profileImage={profileImg}
            role="President"
            color={"#F498C6"}
          />
          <ProfileInfoCard
            name="Abir Rousan"
            profileImage={profileImg}
            role="President"
            color={"#F498C6"}
          />
          <ProfileInfoCard
            name="Abir Rousan"
            profileImage={profileImg}
            role="President"
            color={"#F498C6"}
          />
          <ProfileInfoCard
            name="Abir Rousan"
            profileImage={profileImg}
            role="President"
            color={"#F498C6"}
          />
          <ProfileInfoCard
            name="Abir Rousan"
            profileImage={profileImg}
            role="President"
            color={"#F498C6"}
          />
          <ProfileInfoCard
            name="Abir Rousan"
            profileImage={profileImg}
            role="President"
            color={"#F498C6"}
          />
          <ProfileInfoCard
            name="Abir Rousan"
            profileImage={profileImg}
            role="President"
            color={"#F498C6"}
          />
          <ProfileInfoCard
            name="Abir Rousan"
            profileImage={profileImg}
            role="President"
            color={"#F498C6"}
          />
          <ProfileInfoCard
            name="Abir Rousan"
            profileImage={profileImg}
            role="President"
            color={"#F498C6"}
          />
          <ProfileInfoCard
            name="Abir Rousan"
            profileImage={profileImg}
            role="President"
            color={"#F498C6"}
          />
          <ProfileInfoCard
            name="Abir Rousan"
            profileImage={profileImg}
            role="President"
            color={"#F498C6"}
          />
          <ProfileInfoCard
            name="Abir Rousan"
            profileImage={profileImg}
            role="President"
            color={"#F498C6"}
          />
          <ProfileInfoCard
            name="Abir Rousan"
            profileImage={profileImg}
            role="President"
            color={"#F498C6"}
          />
          <ProfileInfoCard
            name="Abir Rousan"
            profileImage={profileImg}
            role="President"
            color={"#F498C6"}
          />
          <ProfileInfoCard
            name="Abir Rousan"
            profileImage={profileImg}
            role="President"
            color={"#F498C6"}
          />
          <ProfileInfoCard
            name="Abir Rousan"
            profileImage={profileImg}
            role="President"
            color={"#F498C6"}
          />
          <ProfileInfoCard
            name="Abir Rousan"
            profileImage={profileImg}
            role="President"
            color={"#F498C6"}
          />
          <ProfileInfoCard
            name="Abir Rousan"
            profileImage={profileImg}
            role="President"
            color={"#F498C6"}
          />
          <ProfileInfoCard
            name="Abir Rousan"
            profileImage={profileImg}
            role="President"
            color={"#F498C6"}
          />
          <ProfileInfoCard
            name="Abir Rousan"
            profileImage={profileImg}
            role="President"
            color={"#F498C6"}
          />
          <ProfileInfoCard
            name="Abir Rousan"
            profileImage={profileImg}
            role="President"
            color={"#F498C6"}
          />
          <ProfileInfoCard
            name="Abir Rousan"
            profileImage={profileImg}
            role="President"
            color={"#F498C6"}
          />
          <ProfileInfoCard
            name="Abir Rousan"
            profileImage={profileImg}
            role="President"
            color={"#F498C6"}
          />
          <ProfileInfoCard
            name="Abir Rousan"
            profileImage={profileImg}
            role="President"
            color={"#F498C6"}
          />
          <ProfileInfoCard
            name="Abir Rousan"
            profileImage={profileImg}
            role="President"
            color={"#F498C6"}
          />
        </div>
      </div>
      {/* tree structures */}
      <div className="structureTreeView">
        <div className="boardRepresentaion">
          <h3 className="boardRepresentationTitle">Board Structure</h3>
          <Tree
            ref={treeRef}
            renderCustomNodeElement={TreeCustomElement}
            data={boardStructure}
            orientation="vertical"
            pathFunc={"step"}
            zoom={0.5}
            translate={{ x: 300, y: 75 }}
            zoomable
            svgClassName="boardTree"
            leafNodeClassName="leafNode"
            rootNodeClassName="rootNode"
            branchNodeClassName="branchNode"
            onNodeMouseOver={() => nodeVisible()}
          />
        </div>

        <div className="colorRepresentation">
          <h3 className="boardRepresentationTitle">Colour representation</h3>
          <ul className="colorRepresentationList">
            {representColors &&
              representColors.map(({ color, role }, index) => {
                return (
                  <li style={{ "--structureColorRepresentationColor": color }}>
                    {role}
                  </li>
                );
              })}
          </ul>
        </div>
      </div>

      <div className="generalStructureContainer">
        <h3 className="boardRepresentationTitle">General structure</h3>
        <div className="generalStructureBody">
          <Tree
            ref={treeRef}
            renderCustomNodeElement={TreeCustomElement}
            draggable={false}
            data={boardStructure}
            orientation="vertical"
            pathFunc={"step"}
            zoom={0.5}
            translate={{ x: 306, y: 143 }}
            zoomable={false}
            collapsible={true}
            svgClassName="generalTree"
            leafNodeClassName="leafNode"
            rootNodeClassName="rootNode"
            branchNodeClassName="branchNode"
            onNodeMouseOver={() => nodeVisible()}
          />

          <div className="structureAdviceSec">
            <ul>
              <li>
                This is modified structure for better understanding the
                organization.
              </li>
              <li>Each color represents separate positions.</li>
              <li>Top to bottom approached structural organization model.</li>
              <li>Tap on colors get the current position holder.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Body;
